import styled from 'styled-components';

export const Text = styled.p`
    color: #FFF8F5;
    font-weight: normal;

    a {
        color: #474E6B;
    }

    a:hover {
        color: #22283F;
    }
`

export const Container = styled.div`
    background-color: #70AEA9;
    width: 100%;
    padding: 20px;
`

